import ModBadge from "../../components/common/ModBadge";
import TournamentForm from "../../components/forms/TournamentForm";
import { fmt, fmtDate } from "../../services/formatting";
import TorneioInlineEditRow from "./TorneioInlineEditRow";
import { sortTournamentsByName } from "../../services/tournamentSorting";

const TOURNAMENT_COLUMNS = ["Nome", "Buy-in", "Plataforma", "Modalidade", "Criado em", ""];

export default function TorneiosTab({
  tournaments,
  registros,
  tournamentForm,
  tournamentModal,
  handleSaveTournament,
  handleEditTournament,
  handleDeleteTournament,
  setDeleteTarget,
  displayCurrency,
}) {
  return (
    <div>
      <div className="torneios-tab__toolbar">
        <span className="section-count-label">
          {tournaments.length} torneio{tournaments.length !== 1 ? "s" : ""}{" "}
          cadastrado{tournaments.length !== 1 ? "s" : ""}
        </span>
        <button
          className="btn-red registro-primary-action"
          onClick={() => {
            if (tournamentModal.isOpen && !tournamentModal.editingId) {
              tournamentModal.close();
              tournamentForm.reset();
              return;
            }
            tournamentModal.open();
            tournamentForm.reset();
          }}
        >
          {tournamentModal.isOpen && !tournamentModal.editingId
            ? "✕ Cancelar"
            : "+ Criar Novo Torneio"}
        </button>
      </div>

      {tournamentModal.isOpen && !tournamentModal.editingId && (
        <TournamentForm
          form={tournamentForm.values}
          errors={tournamentForm.errors}
          onSubmit={handleSaveTournament}
          onCancel={() => {
            tournamentModal.close();
            tournamentForm.reset();
          }}
          isEditing={!!tournamentModal.editingId}
          onChange={tournamentForm.setValues}
          displayCurrency={displayCurrency}
        />
      )}

      <div className="torneios-table">
        <div className="torneios-table__header">
          {TOURNAMENT_COLUMNS.map((header, index) => (
            <div
              key={index}
              className="torneios-table__heading"
            >
              {header}
            </div>
          ))}
        </div>

        {tournaments.length === 0 && (
          <div className="torneios-table__empty">
            Nenhum torneio criado ainda.
            <br />
            <span className="torneios-table__empty-hint">
              Clique em "+ Criar Novo Torneio" para começar.
            </span>
          </div>
        )}

        {sortTournamentsByName(tournaments)
          .map((tournament, index) => {
            const usos = registros.filter((r) => r.torneioId === tournament.id).length;
            if (tournamentModal.editingId === tournament.id) {
              return (
                <TorneioInlineEditRow
                  key={tournament.id}
                  tournament={tournament}
                  usos={usos}
                  index={index}
                  form={tournamentForm.values}
                  errors={tournamentForm.errors}
                  onChange={tournamentForm.setValues}
                  onSave={handleSaveTournament}
                  onCancel={() => {
                    tournamentModal.close();
                    tournamentForm.reset();
                  }}
                  displayCurrency={displayCurrency}
                />
              );
            }

            return (
              <div key={tournament.id}>
                {index > 0 && <hr className="divider" />}
                <div
                  className={`tr torneios-table__row motion-list-row motion-list-row--${Math.min(index, 8)}`}
                >
                  <div className="torneios-table__name">
                    <div className="torneios-table__name-main">
                      {tournament.nome}
                    </div>
                    {usos > 0 && (
                      <div className="torneios-table__usage torneios-table__usage--name">
                        {usos} registro{usos !== 1 ? "s" : ""}
                      </div>
                    )}
                  </div>
                  <div className="torneios-table__buyin">
                    {fmt(tournament.buyin, tournament.buyinCurrency)}
                  </div>
                  <div className="torneios-table__platform">
                    <span className="platform-badge">
                      {tournament.plataforma || "Sem plataforma"}
                    </span>
                  </div>
                  <div className="torneios-table__modality">
                    <ModBadge mod={tournament.modalidade || "Vanilla"} />
                    {tournament.modalidade === "SAT" && (
                      <div className="torneios-table__ticket-value">
                        Ticket {fmt(tournament.valorTicket || "0", tournament.ticketValueCurrency)}
                      </div>
                    )}
                  </div>
                  <div className="torneios-table__date">
                    {fmtDate(tournament.criadoEm)}
                  </div>
                  <div className="torneios-table__actions">
                    <button
                      className="btn-icon btn-edit"
                      title="Editar"
                      onClick={() => handleEditTournament(tournament)}
                    >
                      ✎
                    </button>
                    <button
                      className="btn-icon btn-del"
                      title="Remover"
                      onClick={() =>
                        setDeleteTarget({ type: "torneio", id: tournament.id })
                      }
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
